export default "__VITE_ASSET__DDsIigEz__"